var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.8665767mm",
    height: "2.8665769mm",
    viewBox: "0 0 2.8665767 2.8665769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-0.04686475,-0.03924239)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e27458",
      fillOpacity: 1,
      strokeWidth: 0.00602794
    },
    id: "path1",
    cx: 1.4801532,
    cy: 1.4725308,
    r: 1.4332885
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M 1.3687016,1.9572576 1.2973881,0.2364324 H 1.6818608 L 1.608997,1.9572576 Z m 0.1333252,0.7580932 q -0.091467,0 -0.1581299,-0.066663 -0.065112,-0.065112 -0.065112,-0.1565796 0,-0.091467 0.065112,-0.1565796 0.066663,-0.065112 0.1581299,-0.065112 0.089917,0 0.1550293,0.065112 0.066663,0.063562 0.066663,0.1565796 0,0.093018 -0.066663,0.1581299 -0.066663,0.065112 -0.1550293,0.065113 z",
    "aria-label": "!"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationPoint);
export default __webpack_public_path__ + "static/media/exclamation-point.a8fdaf44cca8c9ce424f4b61d5ae8961.svg";
export { ForwardRef as ReactComponent };